import { Modal, ModalProps } from 'antd';

import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { BFC } from '@/shared/types';
import { Title } from '@/shared/uikit/Title';
import { useModalsStore } from '@/widgets/modals/modals.store';

type ModalContainerActionsProps = {
  title?: string;
  className?: string;
  closable?: boolean;
};

const MODAL_PIN_STYLES: ModalProps['style'] = {
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  margin: 0,
  top: 'unset',
  width: '100%',
  maxWidth: '100%',
  paddingBottom: 0,
};

const MODAL_STYLES: ModalProps['styles'] = {
  content: {
    borderRadius: '12px 12px 0 0 ',
    minHeight: 200,
    padding: '16px 24px 24px 24px',
  },
  header: {
    marginBottom: 24,
  },
};

export const ModalContainerActions: BFC<ModalContainerActionsProps> = ({
  title,
  className,
  children,
  closable,
}) => {
  const isDesktop = useIsDesktop();
  const modals = useModalsStore();

  return (
    <Modal
      open={true}
      centered={isDesktop}
      footer={null}
      width={'100%'}
      title={
        title ? (
          <Title bold size={16}>
            {title}
          </Title>
        ) : undefined
      }
      onCancel={closable === true || closable === undefined ? modals.closeModal : undefined}
      style={MODAL_PIN_STYLES}
      styles={MODAL_STYLES}
      className={className}
      closable={closable}
    >
      {children}
    </Modal>
  );
};
